import { render } from "./Trips.vue?vue&type=template&id=f1cae280&scoped=true"
import script from "./Trips.vue?vue&type=script&lang=js"
export * from "./Trips.vue?vue&type=script&lang=js"

import "./Trips.vue?vue&type=style&index=0&id=f1cae280&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1cae280"]])

export default __exports__